import { useQuery } from "react-query";
import { PendidikanResponse } from "../../../../models/Pendidikan";
import { PertanyaanResponse } from "../../../../models/Pertanyaan";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const allPertanyaanKey = "all-pertanyaan-key";

export async function allPertanyaan(): Promise<PertanyaanResponse[]> {
  const res = await ApiClient.get(`/AllPertanyaan`);
  return res.data;
}

export default function useFetchAllPertanyaan() {
  return useQuery([allPertanyaanKey], queryWrapper(allPertanyaan));
}
